import React, { createContext, useContext, useState } from 'react';

// Define the shape of your context, now including relationType
interface RelationContextType {
  relationData: any;
  setRelationData: React.Dispatch<React.SetStateAction<any>>;
  relationType: string | null;
  setRelationType: React.Dispatch<React.SetStateAction<string | null>>;
}

// Create the context with default values
const RelationContext = createContext<RelationContextType | undefined>(
  undefined
);

// Create a provider component
export const RelationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [relationData, setRelationData] = useState<any>(null);
  const [relationType, setRelationType] = useState<string | null>(null); // New relationType state

  return (
    <RelationContext.Provider
      value={{ relationData, setRelationData, relationType, setRelationType }}
    >
      {children}
    </RelationContext.Provider>
  );
};

// Create a custom hook for easier access
export const useRelationContext = () => {
  const context = useContext(RelationContext);
  if (!context) {
    throw new Error(
      'useRelationContext must be used within a RelationProvider'
    );
  }
  return context;
};
